import {readLanguage,rememberLanguage} from '../../i18n/languages';
export default function languageSettingsReducer(settings=null,action){
 if(action.type==='SET_LANG')return {currentLang:rememberLanguage(action.value)};
 if(action.type==='LOAD_LANG'){
  const currentLang=readLanguage();
  if(action.value&&typeof action.value.success==='function')action.value.success(currentLang);
  return {currentLang};
 }
 return settings;
}
